/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContextUserEopooDTO } from '../model/contextUserEopooDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ContextUserEopooResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countContextUserEopoos
     * 
     * @param contextUserIdEquals 
     * @param contextUserIdGreaterThan 
     * @param contextUserIdGreaterThanOrEqual 
     * @param contextUserIdIn 
     * @param contextUserIdLessThan 
     * @param contextUserIdLessThanOrEqual 
     * @param contextUserIdNotEquals 
     * @param contextUserIdSpecified 
     * @param eopooCodeContains 
     * @param eopooCodeDoesNotContain 
     * @param eopooCodeEquals 
     * @param eopooCodeIn 
     * @param eopooCodeNotEquals 
     * @param eopooCodeSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextUserIdEquals !== undefined && contextUserIdEquals !== null) {
            queryParameters = queryParameters.set('contextUserId.equals', <any>contextUserIdEquals);
        }
        if (contextUserIdGreaterThan !== undefined && contextUserIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextUserId.greaterThan', <any>contextUserIdGreaterThan);
        }
        if (contextUserIdGreaterThanOrEqual !== undefined && contextUserIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextUserId.greaterThanOrEqual', <any>contextUserIdGreaterThanOrEqual);
        }
        if (contextUserIdIn) {
            contextUserIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextUserId.in', <any>element);
            })
        }
        if (contextUserIdLessThan !== undefined && contextUserIdLessThan !== null) {
            queryParameters = queryParameters.set('contextUserId.lessThan', <any>contextUserIdLessThan);
        }
        if (contextUserIdLessThanOrEqual !== undefined && contextUserIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextUserId.lessThanOrEqual', <any>contextUserIdLessThanOrEqual);
        }
        if (contextUserIdNotEquals !== undefined && contextUserIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextUserId.notEquals', <any>contextUserIdNotEquals);
        }
        if (contextUserIdSpecified !== undefined && contextUserIdSpecified !== null) {
            queryParameters = queryParameters.set('contextUserId.specified', <any>contextUserIdSpecified);
        }
        if (eopooCodeContains !== undefined && eopooCodeContains !== null) {
            queryParameters = queryParameters.set('eopooCode.contains', <any>eopooCodeContains);
        }
        if (eopooCodeDoesNotContain !== undefined && eopooCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('eopooCode.doesNotContain', <any>eopooCodeDoesNotContain);
        }
        if (eopooCodeEquals !== undefined && eopooCodeEquals !== null) {
            queryParameters = queryParameters.set('eopooCode.equals', <any>eopooCodeEquals);
        }
        if (eopooCodeIn) {
            eopooCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('eopooCode.in', <any>element);
            })
        }
        if (eopooCodeNotEquals !== undefined && eopooCodeNotEquals !== null) {
            queryParameters = queryParameters.set('eopooCode.notEquals', <any>eopooCodeNotEquals);
        }
        if (eopooCodeSpecified !== undefined && eopooCodeSpecified !== null) {
            queryParameters = queryParameters.set('eopooCode.specified', <any>eopooCodeSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/context-user-eopoos/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createContextUserEopoo
     * 
     * @param body contextUserEopooDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createContextUserEopooUsingPOST(body: ContextUserEopooDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextUserEopooDTO>;
    public createContextUserEopooUsingPOST(body: ContextUserEopooDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextUserEopooDTO>>;
    public createContextUserEopooUsingPOST(body: ContextUserEopooDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextUserEopooDTO>>;
    public createContextUserEopooUsingPOST(body: ContextUserEopooDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createContextUserEopooUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextUserEopooDTO>('post',`${this.basePath}/api/context-user-eopoos`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteContextUserEopoo
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteContextUserEopooUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteContextUserEopooUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteContextUserEopooUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteContextUserEopooUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteContextUserEopooUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/context-user-eopoos/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllContextUserEopoos
     * 
     * @param contextUserIdEquals 
     * @param contextUserIdGreaterThan 
     * @param contextUserIdGreaterThanOrEqual 
     * @param contextUserIdIn 
     * @param contextUserIdLessThan 
     * @param contextUserIdLessThanOrEqual 
     * @param contextUserIdNotEquals 
     * @param contextUserIdSpecified 
     * @param eopooCodeContains 
     * @param eopooCodeDoesNotContain 
     * @param eopooCodeEquals 
     * @param eopooCodeIn 
     * @param eopooCodeNotEquals 
     * @param eopooCodeSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param page Page number of the requested page
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ContextUserEopooDTO>>;
    public getAllContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContextUserEopooDTO>>>;
    public getAllContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContextUserEopooDTO>>>;
    public getAllContextUserEopoosUsingGET(contextUserIdEquals?: number, contextUserIdGreaterThan?: number, contextUserIdGreaterThanOrEqual?: number, contextUserIdIn?: Array<number>, contextUserIdLessThan?: number, contextUserIdLessThanOrEqual?: number, contextUserIdNotEquals?: number, contextUserIdSpecified?: boolean, eopooCodeContains?: string, eopooCodeDoesNotContain?: string, eopooCodeEquals?: string, eopooCodeIn?: Array<string>, eopooCodeNotEquals?: string, eopooCodeSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, page?: number, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


























        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (contextUserIdEquals !== undefined && contextUserIdEquals !== null) {
            queryParameters = queryParameters.set('contextUserId.equals', <any>contextUserIdEquals);
        }
        if (contextUserIdGreaterThan !== undefined && contextUserIdGreaterThan !== null) {
            queryParameters = queryParameters.set('contextUserId.greaterThan', <any>contextUserIdGreaterThan);
        }
        if (contextUserIdGreaterThanOrEqual !== undefined && contextUserIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextUserId.greaterThanOrEqual', <any>contextUserIdGreaterThanOrEqual);
        }
        if (contextUserIdIn) {
            contextUserIdIn.forEach((element) => {
                queryParameters = queryParameters.append('contextUserId.in', <any>element);
            })
        }
        if (contextUserIdLessThan !== undefined && contextUserIdLessThan !== null) {
            queryParameters = queryParameters.set('contextUserId.lessThan', <any>contextUserIdLessThan);
        }
        if (contextUserIdLessThanOrEqual !== undefined && contextUserIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contextUserId.lessThanOrEqual', <any>contextUserIdLessThanOrEqual);
        }
        if (contextUserIdNotEquals !== undefined && contextUserIdNotEquals !== null) {
            queryParameters = queryParameters.set('contextUserId.notEquals', <any>contextUserIdNotEquals);
        }
        if (contextUserIdSpecified !== undefined && contextUserIdSpecified !== null) {
            queryParameters = queryParameters.set('contextUserId.specified', <any>contextUserIdSpecified);
        }
        if (eopooCodeContains !== undefined && eopooCodeContains !== null) {
            queryParameters = queryParameters.set('eopooCode.contains', <any>eopooCodeContains);
        }
        if (eopooCodeDoesNotContain !== undefined && eopooCodeDoesNotContain !== null) {
            queryParameters = queryParameters.set('eopooCode.doesNotContain', <any>eopooCodeDoesNotContain);
        }
        if (eopooCodeEquals !== undefined && eopooCodeEquals !== null) {
            queryParameters = queryParameters.set('eopooCode.equals', <any>eopooCodeEquals);
        }
        if (eopooCodeIn) {
            eopooCodeIn.forEach((element) => {
                queryParameters = queryParameters.append('eopooCode.in', <any>element);
            })
        }
        if (eopooCodeNotEquals !== undefined && eopooCodeNotEquals !== null) {
            queryParameters = queryParameters.set('eopooCode.notEquals', <any>eopooCodeNotEquals);
        }
        if (eopooCodeSpecified !== undefined && eopooCodeSpecified !== null) {
            queryParameters = queryParameters.set('eopooCode.specified', <any>eopooCodeSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ContextUserEopooDTO>>('get',`${this.basePath}/api/context-user-eopoos`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getContextUserEopoo
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getContextUserEopooUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<ContextUserEopooDTO>;
    public getContextUserEopooUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextUserEopooDTO>>;
    public getContextUserEopooUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextUserEopooDTO>>;
    public getContextUserEopooUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getContextUserEopooUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ContextUserEopooDTO>('get',`${this.basePath}/api/context-user-eopoos/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateContextUserEopoo
     * 
     * @param body contextUserEopooDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateContextUserEopooUsingPUT(body: ContextUserEopooDTO, observe?: 'body', reportProgress?: boolean): Observable<ContextUserEopooDTO>;
    public updateContextUserEopooUsingPUT(body: ContextUserEopooDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextUserEopooDTO>>;
    public updateContextUserEopooUsingPUT(body: ContextUserEopooDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextUserEopooDTO>>;
    public updateContextUserEopooUsingPUT(body: ContextUserEopooDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateContextUserEopooUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ContextUserEopooDTO>('put',`${this.basePath}/api/context-user-eopoos`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
